var _rect, _path, _path2, _ellipse, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMeds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4132 44.4H21.9688V29H22.0186C22.58 22.8328 27.8154 18 34.191 18C40.5666 18 45.802 22.8328 46.3634 29H46.4132V44.4Z",
    fill: "#D4D3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9688 40.0001L34.1478 40.0001C34.1622 40 34.1766 40 34.191 40C34.2054 40 34.2197 40 34.2341 40.0001L46.4132 40.0001L46.4132 51.0001H46.3634C45.802 57.1672 40.5666 62 34.191 62C27.8154 62 22.58 57.1672 22.0186 51.0001H21.9688L21.9688 40.0001Z",
    fill: "#8E8CEE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.75,
    cy: 47.6437,
    rx: 10,
    ry: 10,
    transform: "rotate(-180 49.75 47.6437)",
    fill: "#8E8CEE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.8906,
    cy: 47.6437,
    r: 10,
    transform: "rotate(-90 47.8906 47.6437)",
    fill: "url(#paint0_linear_25245_12975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25245_12975",
    x1: 48.4838,
    y1: 47.1847,
    x2: 58.3744,
    y2: 61.8773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#D2D1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeds);
export default __webpack_public_path__ + "static/media/icon-meds.3e3a2ac73d131078e318c2caf5d5e7aa.svg";
export { ForwardRef as ReactComponent };